import { useMutation, useQueryClient } from "@tanstack/react-query";
import { cloneDeep } from "lodash";
import { karlFarmDelete, karlFarmQueryClient } from "./queryClient";
import { AllTasksResponse, getUseAllTasksQueryKey } from "./useAllTasks";

// Route: DELETE /data/tasks/{id}
// API Docs: https://documenter.getpostman.com/view/16381164/UVksNF2z#19193064-96c3-47e8-8933-259f066fb6e4

const getDeleteTaskPath = (id: string) => `/data/tasks/${id}`;

export const useDeleteTaskMutation = () => {
  const queryClient = useQueryClient();
  const tasksQueryKey = getUseAllTasksQueryKey();

  return useMutation((id: string) => karlFarmDelete(getDeleteTaskPath(id)), {
    onMutate: async (id: string) => {
      await queryClient.cancelQueries({ queryKey: tasksQueryKey });

      const previousTasks = queryClient.getQueryData(tasksQueryKey);

      deleteTaskQueryData(id);

      return { previousTasks };
    },
    onError: (error, _, context) => {
      queryClient.setQueryData(tasksQueryKey, context?.previousTasks);
      console.error(error);
    },
    onSettled: () => {
      queryClient.invalidateQueries(tasksQueryKey);
    },
  });
};

export const deleteTaskQueryData = (id: string) => {
  karlFarmQueryClient.setQueryData<AllTasksResponse>(
    getUseAllTasksQueryKey(),
    (old: AllTasksResponse | undefined) => {
      if (old == null) return undefined;
      const newTasks = cloneDeep(old);
      if (newTasks.data == null) return undefined;
      const indexToRemove = newTasks.data.tasks.findIndex(
        (task) => task.id === id
      );
      if (indexToRemove === -1) return undefined;
      newTasks.data.tasks.splice(indexToRemove, 1);
      return newTasks;
    }
  );
};
